import { Injectable } from '@angular/core';
import { JobAssignment } from 'src/app/timeline-skip/models/job-assignment.model';
import { Subject } from 'rxjs';
import { Job } from 'src/app/timeline-skip/models/job.model';

@Injectable({
  providedIn: 'root'
})
export class TimelineTransportStateService {

  $transportJobAssignmentAdded: Subject<JobAssignment> = new Subject();
  $transportJobAssignmentDeleted: Subject<number> = new Subject();
  $transportVorAndAbsenceChanged: Subject<any> = new Subject();
  $JobAssignmentChanged: Subject<JobAssignment> = new Subject();
  $transportDragDataChanged: Subject<any> = new Subject();
  $transportNewJobDialogClosed: Subject<Job> = new Subject();
  $transportSelectedJobsChanged: Subject<Job[]> = new Subject();
  $transportSelectedJobAssignmentsChanged: Subject<JobAssignment[]> = new Subject();
  $transportDateChanged: Subject<any> = new Subject();
  $transportOrderTypeChanged: Subject<number> = new Subject();
  $transportActiveBlockNumberChange: Subject<number> = new Subject();
  $transportJobAssignmentsUpdated: Subject<any> = new Subject();
  $transportCopyDataUpdated: Subject<any> = new Subject();
  $transportOrderIdChanged: Subject<number> = new Subject();
  $transportEditOrderDialogueClosed: Subject<any> = new Subject();
  $transportUnitsChanged: Subject<any> = new Subject();
  $transportJobCopyUnitDialogClosed: Subject<any> = new Subject();
  // Toolbar (a sibling of the main grid component, not a parent/child) triggers the PDF download
  // that's actually implemented against the grid's own loaded jobAssignments.
  $transportDownloadSheetRequested: Subject<void> = new Subject();
  // Same cross-component pattern - the actual note-creation flow depends on the grid's own
  // selectedAssignments (which driver rows are checked), so it stays there; the toolbar only asks.
  $transportAddDriverNoteRequested: Subject<void> = new Subject();
  // Unit search (hides whole rows) and job status filter (dims individual blocks) - the toolbar
  // owns the input controls, the grid owns jobAssignments and does the actual filtering.
  $transportUnitSearchChanged: Subject<string> = new Subject();
  $transportUnitStatusFilterChanged: Subject<string> = new Subject();
  // Presence + change notification (main grid owns the socket connection since it already owns
  // date/orderTypeId; the toolbar just displays what it's handed).
  $transportPresenceChanged: Subject<any[]> = new Subject();
  // Chat panel owns its own open/closed + unread state; the toolbar only requests a toggle and
  // displays whatever unread count it's handed, same split as presence above.
  $transportChatPanelToggled: Subject<void> = new Subject();
  $transportChatUnreadCountChanged: Subject<number> = new Subject();


  constructor() { }
}
